import React from 'react';
import { Heart } from 'lucide-react';
import XPBar from '../XPBar';
import { ASSETS } from '../../assetManifest.js';
import { CONSTANTS } from '../../data';

interface HeaderStatsProps {
  coins: number;
  xp: number;
  level: number;
  reputation: number;
  prestigeLevel: number;
  openTooltip: string | null;
  onToggleTooltip: (id: string) => void;
  isMobile: boolean;
}

const HeaderStats: React.FC<HeaderStatsProps> = ({
  coins,
  xp,
  level,
  reputation,
  prestigeLevel,
  openTooltip,
  onToggleTooltip,
  isMobile,
}) => {
  const getReputationLevel = (rep: number) => {
    const levels = CONSTANTS.REPUTATION_CONFIG.LEVELS;
    if (rep >= levels.LOVED.threshold) return levels.LOVED;
    if (rep >= levels.LIKED.threshold) return levels.LIKED;
    if (rep >= levels.NEUTRAL.threshold) return levels.NEUTRAL;
    if (rep >= levels.DISLIKED.threshold) return levels.DISLIKED;
    return levels.HATED;
  };

  const reputationLevel = getReputationLevel(reputation);

  return (
    <>
      <span className="header-stat font-bold text-sm sm:text-lg">💰{isMobile ? coins : ` ${coins}`}</span>
      <XPBar xp={xp} level={level} onToggleTooltip={() => onToggleTooltip('xp')} isOpen={openTooltip === 'xp'} />
      <div
        className="flex items-center gap-1 bg-black bg-opacity-20 px-1.5 sm:px-3 py-0.5 sm:py-1 rounded-full reputation-tooltip-trigger tooltip-trigger cursor-pointer"
        style={{ color: reputationLevel.color }}
        onClick={() => onToggleTooltip('reputation')}
      >
        <Heart size={isMobile ? 12 : 16} />
        <span className="font-bold text-xs sm:text-sm">{reputation}</span>
        <div className={`reputation-tooltip ${openTooltip === 'reputation' ? 'tooltip-visible' : ''}`}>
          <h4 className="font-bold mb-1 border-b border-gray-500 pb-1">Reputation: {reputationLevel.name}</h4>
          <p className="text-xs mt-1">Your cafe's reputation affects customer patience and the types of customers you attract.</p>
        </div>
      </div>
      {prestigeLevel > 0 && (
        <div
          className="flex items-center gap-0.5 sm:gap-1 bg-purple-600 px-1.5 sm:px-2 py-0.5 sm:py-1 rounded-full"
          title={`Prestige Level ${prestigeLevel}`}
        >
          <img
            src={ASSETS.icons.prestige.path}
            alt="Prestige"
            className="w-2.5 h-2.5 sm:w-4 sm:h-4"
          />
          <span className="font-bold text-xs">
            {CONSTANTS.PRESTIGE.LEVELS[prestigeLevel]?.ui}
          </span>
        </div>
      )}
    </>
  );
};

export default HeaderStats;
